(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('QueueStatus', QueueStatus);

    QueueStatus.$inject = ['$resource'];

    function QueueStatus ($resource) {
        var resourceUrl =  'api/queue-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
